/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#clip0)" _stroke="#FF3A2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8v4M12 16h.01"/></g><defs><clipPath id="clip0"><path pid="1" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
